import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { ModificationRequestMachineStateDescriptor } from './model/modification.request';

@Injectable()
export class ModificationRequestMachineService extends RESTServiceBase {

  constructor(authService: AuthService, config: AppConfig) {
    super(
      'v1',
      'ModificationRequestMachineManagement',
      authService,
      config.CMSConfig
    );
  }

  public async getExpectedStates(dataEntryId: string): Promise<ModificationRequestMachineStateDescriptor[]> {
    return super.get<ModificationRequestMachineStateDescriptor[]>(dataEntryId);
  }

  public async set(dataEntryId: string, state: ModificationRequestMachineStateDescriptor): Promise<void> {
    return super.patch<any>(dataEntryId, state);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/modification.request/modification.request.machine.service.ts